// Issue #197 (EU-KI-Act Art. 14): Trainer-Review von KI-Bewertungen.
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

async function fetchAPI(url: string, options: RequestInit = {}): Promise<any> {
  const token = localStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...options.headers,
  };

  const response = await fetch(url, { ...options, headers });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.error || `HTTP error! status: ${response.status}`);
  }

  return response.json();
}

export interface GradingReviewItem {
  id: number;
  userId: number | null;
  lessonId: number | null;
  lessonTitle: string | null;
  courseId: number | null;
  courseTitle: string | null;
  answer: string | null;
  score: number | null;
  minScore: number | null;
  passed: boolean;
  feedback: string | null;
  aiFeedback: { strengths?: string[]; improvements?: string[] } | null;
  gradingStatus: 'ai_pending_review' | 'ai_graded' | 'teacher_reviewed' | 'teacher_overridden';
  originalAiScore: number | null;
  reviewedBy: number | null;
  reviewedAt: string | null;
  reviewNote: string | null;
  attemptedAt: string | null;
}

export interface GradingReviewFilters {
  status?: string;
  courseId?: number;
  minScore?: number;
  maxScore?: number;
}

export const aiGradingReviewService = {
  async list(filters: GradingReviewFilters = {}): Promise<{ items: GradingReviewItem[]; count: number }> {
    const params = new URLSearchParams();
    if (filters.status) params.set('status', filters.status);
    if (filters.courseId) params.set('courseId', String(filters.courseId));
    if (filters.minScore !== undefined) params.set('minScore', String(filters.minScore));
    if (filters.maxScore !== undefined) params.set('maxScore', String(filters.maxScore));

    return fetchAPI(`${API_BASE_URL}/api/ai/grading-reviews?${params.toString()}`);
  },

  async approve(id: number, note?: string): Promise<{ attempt: GradingReviewItem; lessonCompleted: boolean }> {
    return fetchAPI(`${API_BASE_URL}/api/ai/grading-reviews/${id}/approve`, {
      method: 'POST',
      body: JSON.stringify(note ? { note } : {}),
    });
  },

  async override(
    id: number,
    payload: { score: number; feedback?: string; note?: string }
  ): Promise<{ attempt: GradingReviewItem; lessonCompleted: boolean }> {
    return fetchAPI(`${API_BASE_URL}/api/ai/grading-reviews/${id}/override`, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },
};
